import { render } from "./PostPassportSection.vue?vue&type=template&id=b45ba312&scoped=true"
import script from "./PostPassportSection.vue?vue&type=script&lang=js"
export * from "./PostPassportSection.vue?vue&type=script&lang=js"

import "@/assets/widget.css?vue&type=style&index=0&id=b45ba312&scoped=true&lang=css&external"
import "./PostPassportSection.vue?vue&type=style&index=1&id=b45ba312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45ba312"]])

export default __exports__